//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from '@/components/Shared/Button.vue'
import ModalWithTitleBar from '@/components/Shared/ModalWithTitleBar'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Button,
    ModalWithTitleBar,
    Multiselect,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    supervisors: {
      type: Array,
      default: () => [],
    },
    unassignedCollaborators: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedSupervisor: {},
      confirmDisabled: false,
      supervisorsOptions: [],
    }
  },
  watch: {
    unassignedCollaborators() {
      this.selectedSupervisor = {}
      this.confirmDisabled = true
    },
    supervisors() {
      this.supervisorsOptions = this.supervisors.map((sv) => {
        return {
          id: sv.user,
          name: `${sv.names} ${sv.lastnames}`,
        }
      })
    },
  },
  methods: {
    onClose() {
      this.$emit('close', true)
    },
    assignLater() {
      this.$emit('assign-later', this.unassignedCollaborators)
    },
    onConfirm() {
      const assignedSupervisorsObj = {}

      for (const collab in this.selectedSupervisor) {
        const supervisor = this.selectedSupervisor[collab].id
        if (!assignedSupervisorsObj[supervisor]) {
          assignedSupervisorsObj[supervisor] = []
        }
        assignedSupervisorsObj[supervisor].push(collab)
      }

      const assignedSupervisorsArray = Object.entries(
        assignedSupervisorsObj
      ).map(([supervisorId, collaboratorsId]) => ({
        supervisorId,
        collaboratorsId,
      }))

      this.$emit('confirm', assignedSupervisorsArray)
    },
    validate() {
      this.confirmDisabled = !this.unassignedCollaborators.every(
        (collab) => this.selectedSupervisor[collab.id]
      )
    },
  },
}
